import { useEffect } from 'react';
import { setStoredReferralCode } from '@/utils/referralStorage';

export { REFERRAL_STORAGE_KEY } from '@/utils/referralStorage';

/**
 * Hook que captura o código de indicação da URL (suporta ?ref=, ?r=, ?indicacao=, ?referral=)
 * e o armazena de forma resiliente em Cookies e localStorage.
 */
export function useReferralCapture() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      const urlParams = new URLSearchParams(window.location.search);
      const refCode =
        urlParams.get('ref') ||
        urlParams.get('r') ||
        urlParams.get('indicacao') ||
        urlParams.get('referral');

      if (refCode && refCode.trim() !== '') {
        setStoredReferralCode(refCode.trim());
      }
    } catch (error) {
      console.error('Error capturing referral code:', error);
    }
  }, []);
}

